// Set the language of the UserWay widget based on the page language

import { getPageLang } from './utils';

document.addEventListener('userway:init_completed', function(event: CustomEvent) {
  const instance = event.detail.userWayInstance;
  const language = getPageLang();
  instance.changeWidgetLanguage(language);
});
